import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@components/common/Modal/Modal';
import { useHandleSubscriptionModalClose } from '@components/templates/employer/subscription/utils';
import { TalentSubscriptionHubModal } from '@components/templates/talent/subscription/TalentSubscriptionHubModal';
import { ApiUserSubscriptionPaymentDetailsOk } from '@type/v1-api-types/user-subscription';

// Interface
// *****************************************************
interface TalentSubscriptionModalProps {
  locale: Locale,
  paymentDetailsServer?: ApiUserSubscriptionPaymentDetailsOk,
}


/**
 * @description Renders the user premium subscription modal, with payment options, pricing and if
 * it's the case the 'not enough credits' and payment status possible steps.
 * The modal can be opened anywhere in the app using the **showTalentSubscriptionModal** function.
 */
export const TalentSubscriptionModal = NiceModal.create((props: TalentSubscriptionModalProps) => {
  // Destructure props
  const {
    locale,
    paymentDetailsServer,
  } = props;

  // Use a hook to manage the modal state
  const modal = useModal();

  // Close modal
  const closeModal = () => {
    void modal.hide();
  };

  // Cleanup Redux states and re-fetch after closing the modal depending on the flow step
  const { handleSubscriptionModalClose } = useHandleSubscriptionModalClose();

  // Render component
  // *****************************************
  return (
    <Modal
      isOpen={modal.visible}
      onClose={closeModal}
      backdropClickDisabled
      afterLeave={handleSubscriptionModalClose}
      size="lg"
      header="Comanda ta"
      body={<TalentSubscriptionHubModal paymentDetailsServer={paymentDetailsServer} locale={locale} />}
    />
  );
});


/**
 * @description Opens the Premium talent subscription modal anywhere in the app.
 *
 * @example
 * // import
 * import { showTalentSubscriptionModal } from '@components/templates/talent/subscription/TalentSubscriptionModal';
 * // usage
 * <Button onClick={showTalentSubscriptionModal}>Show user premium talent subscription modal</Button>
 */
export const showTalentSubscriptionModal = (locale: Locale, paymentDetailsServer?: ApiUserSubscriptionPaymentDetailsOk) => {
  void NiceModal.show(TalentSubscriptionModal, { locale, paymentDetailsServer });
};
